import React, { useState } from 'react'
import $ from 'jquery'
import Swal from 'sweetalert2'
import Combo_course from '../Component/Combo_course'
import Combo_course_mobile from '../Component/Combo_course_mobile'
import Total_Count from '../Component/Total_Count'
import Counsellor from '../Component/Counsellor'
import { PiArrowCircleRightThin } from 'react-icons/pi'
import { HiOutlineBuildingLibrary } from 'react-icons/hi2'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'

function Combo_page() {
  const benefits = [
    'Industrial Experts/Mentors',
    'Tailored Curriculum',
    'Continuous Innovation',
    'Interactive Learning Tools',
    'Dedicated Support team',
    'Lifetime Access',
    'Industrial Projects',
    'Hands on Experience',
  ]
  const programs = [
    'Artificial Intelligence',
    'Machine Learning',
    'Web Development',
    'Data Science',
    'Android App Development',
    'Robotics',
    'Cyber Security',
    'Cloud Computing',
    'Human Resource',
    'Finance',
    'Business Analytics',
    'AutoCAD',
    'Digital Marketing',
    'VLSI',
    'Internet of Things',
    'Embedded System',
  ]

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
    Program1: '',
    Program2: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [collegeError, setCollegeError] = useState('')
  const [program1Error, setProgram1Error] = useState('')
  const [program2Error, setProgram2Error] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    switch (name) {
      case 'fullName':
        if (!value || !/^[A-Za-z\s]+$/.test(value)) {
          setNameError('Invalid name format.')
        } else {
          setNameError('')
        }
        break
      case 'email':
        if (!value || !/\S+@\S+\.\S+/.test(value)) {
          setEmailError('Invalid email format.')
        } else {
          setEmailError('')
        }
        break
      case 'mobileNo':
        if (!value || !/^\d{10}$/.test(value)) {
          setPhoneError('Length should be 10 digits.')
        } else {
          setPhoneError('')
        }
        break
      case 'collegeName':
        if (!value || !/^[A-Za-z\s]+$/.test(value)) {
          setCollegeError('Invalid college name format.')
        } else {
          setCollegeError('')
        }
        break
      case 'Program1':
        if (!value) {
          setProgram1Error('Please select both programs.')
        } else {
          setProgram1Error('')
        }
        break
      case 'Program2':
        if (!value) {
          setProgram2Error('Please select both programs.')
        } else {
          setProgram2Error('')
        }
        break
      default:
        break
    }

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    $.ajax({
      url: 'https://forms.internselite.net/Combo-Program',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val(),
        Program1: $('[name="Program1"]').val(),
        Program2: $('[name="Program2"]').val(),
      },
      success: function (response) {
        Swal.fire({
          title: 'Form Submitted!',
          text:
            'Thank you for choosing to advance your learning with us! We’ve received your application for the combo program, and we’re excited to see your enthusiasm for growth. Stay tuned for the next steps!',
          icon: 'success',
        })
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
        $('[name="collegeName"]').val('')
        $('[name="Program1"]').val('')
        $('[name="Program2"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }

  return (
    <>
      <div>
        {/* -----------------------Mobile View------------------------ */}
        <div className="Combo_background_image d-sm-block d-md-none mt-5">
          <div className="container-fluid Combo_background_color pt-5">
            <div className="text-center Combo_Main_text py-5">
              <h1 className="display-2 pt-5 text-white">Combo Program</h1>
            </div>
          </div>
        </div>

        {/* -------------------Desktop View------------------------- */}
        <div className="Combo_background_image d-none d-md-block mt-5">
          <div className="container-fluid Combo_background_color py-5">
            <div className="text-center pt-5 Combo_Main_text mt-5">
              <h1 className="display-3 py-5 mt-4 mb-5 text-white">
                Combo Program
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-2">
        <div className="container">
          <div className="container">
            <div className="d-none d-md-block px-3 py-5">
              <Combo_course />
            </div>
            <div className="d-sm-block d-md-none mt-3">
              <Combo_course_mobile />
            </div>
            {/* -------------------------Desktop View----------------------------- */}
           
              <div className="container combo_box_text">
                <div className="row mt-4">
                  <div className="col-md-8 border rounded px-3 pt-3">
                    <div>
                      <div className="border-bottom pb-3">
                        <h2 className="fs-6 fw-bold">
                          Couldn't find your preferred courses?
                        </h2>
                        <h2 className="fs-1">Customise Your Own</h2>
                      </div>
                      <div className="row mt-4">
                        {benefits.map((benefit, index) => (
                          <div className="col-md-6" key={index}>
                            <div className="row">
                              <div className="col-1">
                                <PiArrowCircleRightThin
                                  size="20px"
                                  color="#2b1c50"
                                />
                              </div>
                              <div className="col-11">
                                <p>{benefit}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 d-none d-md-block">
                    <div className="">
                      <div className="Program_details_form px-4">
                        <div className="py-4">
                          <form onSubmit={handleSubmit}>
                            <div className="mt-2">
                              <label for="fullName" class="pb-2 contact_form">
                                <SlUser size="18px" /> Full Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="fullName"
                                name="fullName"
                                placeholder="Full Name"
                                value={formData.fullName}
                                onChange={handleInputChange}
                                required
                              />
                              {nameError && (
                                <div className="error text-danger">
                                  {nameError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="email" class="pb-2 contact_form">
                                <MdOutlineMailOutline size="18px" /> Email
                                Address
                              </label>
                              <input
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                              />
                              {emailError && (
                                <div className="error text-danger">
                                  {emailError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="mobileNo" class="pb-2 contact_form">
                                <HiOutlinePhone size="18px" /> Phone Number
                              </label>
                              <input
                                className="form-control"
                                type="tel"
                                id="mobileNo"
                                name="mobileNo"
                                placeholder="+91 xxxxxxxxxx"
                                value={formData.mobileNo}
                                onChange={handleInputChange}
                                required
                              />
                              {phoneError && (
                                <div className="error text-danger">
                                  {phoneError}
                                </div>
                              )}
                            </div>
                            <div class="mt-3">
                              <label
                                for="collegeName"
                                class="pb-2 contact_form"
                              >
                                <HiOutlineBuildingLibrary size="18px" /> College
                                Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="collegeName"
                                name="collegeName"
                                placeholder="Your answer"
                                value={formData.collegeName}
                                onChange={handleInputChange}
                                required
                              />
                              {collegeError && (
                                <div className="error text-danger">
                                  {collegeError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program1"
                                className="pb-2 contact_form"
                              >
                                Program 1
                              </label>
                              <select
                                className="form-control"
                                id="Program1"
                                name="Program1"
                                value={formData.Program1}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program1, index) => (
                                  <option value={Program1} key={index}>
                                    {Program1}
                                  </option>
                                ))}
                              </select>
                              {program1Error && (
                                <div className="error text-danger">
                                  {program1Error}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program2"
                                className="pb-2 contact_form"
                              >
                                Program 2
                              </label>
                              <select
                                className="form-control"
                                id="Program2"
                                name="Program2"
                                value={formData.Program2}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program2, index) => (
                                  <option value={Program2} key={index}>
                                    {Program2}
                                  </option>
                                ))}
                              </select>
                              {program2Error && (
                                <div className="error text-danger">
                                  {program2Error}
                                </div>
                              )}
                            </div>

                            <div className="row mt-2 pt-4">
                              <div className="d-flex justify-content-center">
                                <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 my-2 d-sm-block d-md-none">
                    <div className="">
                      <div className="Program_details_form px-4">
                        <div className="py-4">
                          <form onSubmit={handleSubmit}>
                            <div className="mt-2">
                              <label for="fullName" class="pb-2 contact_form">
                                <SlUser size="18px" /> Full Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="fullName"
                                name="fullName"
                                placeholder="Full Name"
                                value={formData.fullName}
                                onChange={handleInputChange}
                                required
                              />
                              {nameError && (
                                <div className="error text-danger">
                                  {nameError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="email" class="pb-2 contact_form">
                                <MdOutlineMailOutline size="18px" /> Email
                                Address
                              </label>
                              <input
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                              />
                              {emailError && (
                                <div className="error text-danger">
                                  {emailError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="mobileNo" class="pb-2 contact_form">
                                <HiOutlinePhone size="18px" /> Phone Number
                              </label>
                              <input
                                className="form-control"
                                type="tel"
                                id="mobileNo"
                                name="mobileNo"
                                placeholder="+91 xxxxxxxxxx"
                                value={formData.mobileNo}
                                onChange={handleInputChange}
                                required
                              />
                              {phoneError && (
                                <div className="error text-danger">
                                  {phoneError}
                                </div>
                              )}
                            </div>
                            <div class="mt-3">
                              <label
                                for="collegeName"
                                class="pb-2 contact_form"
                              >
                                <HiOutlineBuildingLibrary size="18px" /> College
                                Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="collegeName"
                                name="collegeName"
                                placeholder="Your answer"
                                value={formData.collegeName}
                                onChange={handleInputChange}
                                required
                              />
                              {collegeError && (
                                <div className="error text-danger">
                                  {collegeError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program1"
                                className="pb-2 contact_form"
                              >
                                Program 1
                              </label>
                              <select
                                className="form-control"
                                id="Program1"
                                name="Program1"
                                value={formData.Program1}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program1, index) => (
                                  <option value={Program1} key={index}>
                                    {Program1}
                                  </option>
                                ))}
                              </select>
                              {program1Error && (
                                <div className="error text-danger">
                                  {program1Error}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program2"
                                className="pb-2 contact_form"
                              >
                                Program 2
                              </label>
                              <select
                                className="form-control"
                                id="Program2"
                                name="Program2"
                                value={formData.Program2}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program2, index) => (
                                  <option value={Program2} key={index}>
                                    {Program2}
                                  </option>
                                ))}
                              </select>
                              {program2Error && (
                                <div className="error text-danger">
                                  {program2Error}
                                </div>
                              )}
                            </div>

                            <div className="row mt-2 pt-4">
                              <div className="d-flex justify-content-center">
                                <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            {/* --------------------------Mobile View----------------------------- */}
            {/* <div className="d-sm-block d-md-none mt-5">
              <div className="container border rounded py-3 combo_box_text">
                <div className="row">
                  <div className="col-md-8">
                    <div>
                      <div className="border-bottom pb-3">
                        <h1 className="fw-bold">
                          Couldn't find your preferred courses?
                        </h1>
                        <h2 className="fs-1">Customise Your Own</h2>
                      </div>
                      <div className="row my-4">
                        {benefits.map((benefit, index) => (
                          <div className="col-md-6" key={index}>
                            <div className="row">
                              <div className="col-1">
                                <PiArrowCircleRightThin
                                  size="20px"
                                  color="#2b1c50"
                                />
                              </div>
                              <div className="col-11">
                                <p>{benefit}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="">
                      <div className="Program_details_form px-4">
                        <div className="py-4">
                          <form onSubmit={handleSubmit}>
                            <div className="mt-2">
                              <label for="fullName" class="pb-2 contact_form">
                                <SlUser size="18px" /> Full Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="fullName"
                                name="fullName"
                                placeholder="Full Name"
                                value={formData.fullName}
                                onChange={handleInputChange}
                                required
                              />
                              {nameError && (
                                <div className="error text-danger">
                                  {nameError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="email" class="pb-2 contact_form">
                                <MdOutlineMailOutline size="18px" /> Email
                                Address
                              </label>
                              <input
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email Address"
                                value={formData.email}
                                onChange={handleInputChange}
                                required
                              />
                              {emailError && (
                                <div className="error text-danger">
                                  {emailError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label for="mobileNo" class="pb-2 contact_form">
                                <HiOutlinePhone size="18px" /> Phone Number
                              </label>
                              <input
                                className="form-control"
                                type="tel"
                                id="mobileNo"
                                name="mobileNo"
                                placeholder="+91 xxxxxxxxxx"
                                value={formData.mobileNo}
                                onChange={handleInputChange}
                                required
                              />
                              {phoneError && (
                                <div className="error text-danger">
                                  {phoneError}
                                </div>
                              )}
                            </div>
                            <div class="mt-3">
                              <label
                                for="collegeName"
                                class="pb-2 contact_form"
                              >
                                <HiOutlineBuildingLibrary size="18px" /> College
                                Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                id="collegeName"
                                name="collegeName"
                                placeholder="Your answer"
                                value={formData.collegeName}
                                onChange={handleInputChange}
                                required
                              />
                              {collegeError && (
                                <div className="error text-danger">
                                  {collegeError}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program1"
                                className="pb-2 contact_form"
                              >
                                Program 1
                              </label>
                              <select
                                className="form-control"
                                id="Program1"
                                name="Program1"
                                value={formData.Program1}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program1, index) => (
                                  <option value={Program1} key={index}>
                                    {Program1}
                                  </option>
                                ))}
                              </select>
                              {program1Error && (
                                <div className="error text-danger">
                                  {program1Error}
                                </div>
                              )}
                            </div>
                            <div className="mt-3">
                              <label
                                htmlFor="Program2"
                                className="pb-2 contact_form"
                              >
                                Program 2
                              </label>
                              <select
                                className="form-control"
                                id="Program2"
                                name="Program2"
                                value={formData.Program2}
                                onChange={handleInputChange}
                                required
                              >
                                <option value="">Select a Program...</option>
                                {programs.map((Program2, index) => (
                                  <option value={Program2} key={index}>
                                    {Program2}
                                  </option>
                                ))}
                              </select>
                              {program2Error && (
                                <div className="error text-danger">
                                  {program2Error}
                                </div>
                              )}
                            </div>

                            <div className="row mt-2 pt-4">
                              <div className="d-flex justify-content-center">
                                <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <Total_Count />
        <div className="mt-5">
          <Counsellor />
        </div>
      </div>
    </>
  )
}

export default Combo_page
